import React from "react"
import PropTypes from "prop-types"

import { NEGATIVE } from "../../utils/constants"
import { colors } from "../../theme"
import { ExternalLinkIcon } from "../../icons"
import { Link } from "gatsby"
import { Tooltip } from "react-tooltip"

export function ProductsTable({ dois }) {
  const linkLimit = 3

  return (
    <table
      css={`
        background: rgba(255, 255, 255, 0.06);
        border-spacing: 30px;
        th:first-child {
          padding-left: 1.25rem;
        }
      `}
    >
      <thead>
        <tr>
          <th>DATA PRODUCT</th>
          <th>PLATFORMS</th>
          <th>INSTRUMENTS</th>
        </tr>
      </thead>
      <tbody>
        {dois
          .filter(doi => doi.doi)
          .map(doi => (
            <tr key={doi.id}>
              <td
                css={`
                  max-width: 30vw;
                `}
              >
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`http://dx.doi.org/${doi.doi}`}
                  css={`
                    color: ${colors[NEGATIVE].linkText};
                    display: inline-flex;
                    flex-flow: row nowrap;
                    gap: 0.25rem;
                    align-items: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    padding-left: 1.5rem;
                    svg {
                      width: 12px;
                      height: 12px;
                      flex-shrink: 0;
                    }
                  `}
                  data-cy={`doi-link`}
                >
                  <span>{doi.shortname}</span>
                  <ExternalLinkIcon color={colors[NEGATIVE].linkText} />{" "}
                </a>
              </td>
              <td>
                <span>
                  <span>
                    {doi.platforms.length ? (
                      doi.platforms.map((item, idx) => {
                        if (idx < linkLimit) {
                          const spacer =
                            idx < Math.min(doi.platforms.length, linkLimit) - 1
                              ? ", "
                              : ""
                          return (
                            <span key={idx}>
                              <Link
                                to={`/platform/${item.shortname}`}
                                css={`
                                  font-weight: 600;
                                `}
                                data-cy={`${item.id}-inpage-link`}
                              >
                                {item.shortname + spacer}
                              </Link>
                            </span>
                          )
                        }
                      })
                    ) : (
                      <>
                        <span
                          data-tooltip-id={`tooltip-platform-${doi.id}`}
                          style={{ fontSize: 25 }}
                        >
                          {"---"}
                        </span>
                        <Tooltip
                          id={`tooltip-platform-${doi.id}`}
                          content="Please visit product page"
                          place="bottom"
                        />
                      </>
                    )}
                  </span>
                  {doi.platforms.length > linkLimit ? (
                    <>{`, +${doi.platforms.length - linkLimit}`}</>
                  ) : (
                    <></>
                  )}
                </span>
              </td>
              <td>
                <span>
                  <span>
                    {doi.instruments.length ? (
                      doi.instruments.map((item, idx) => {
                        if (idx < linkLimit) {
                          const spacer =
                            idx <
                            Math.min(doi.instruments.length, linkLimit) - 1
                              ? ", "
                              : ""
                          return (
                            <span key={idx}>
                              <Link
                                to={`/instrument/${item.shortname}`}
                                css={`
                                  font-weight: 600;
                                `}
                                data-cy={`${item.id}-inpage-link`}
                              >
                                {item.shortname + spacer}
                              </Link>
                            </span>
                          )
                        }
                      })
                    ) : (
                      <>
                        <span
                          data-tooltip-id={`tooltip-instrument-${doi.id}`}
                          style={{ fontSize: 25 }}
                        >
                          {"---"}
                        </span>
                        <Tooltip
                          id={`tooltip-instrument-${doi.id}`}
                          content="Please visit product page"
                          place="bottom"
                        />
                      </>
                    )}
                  </span>
                  {doi.instruments.length > linkLimit ? (
                    <>{`, +${doi.instruments.length - linkLimit}`}</>
                  ) : (
                    <></>
                  )}
                </span>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}

ProductsTable.propTypes = {
  dois: PropTypes.arrayOf(
    PropTypes.shape({
      cmrTitle: PropTypes.string,
      doi: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      longname: PropTypes.string,
    })
  ).isRequired,
}
